import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { cn } from '@/lib/utils';

/**
 * A QR code drawn in the browser. An authenticator QR carries the account's
 * two-factor secret, so it must never go to an image service: the MFA page
 * used to ask api.qrserver.com to draw it, which put the secret in that
 * service's request logs. Black on white so it scans in either theme.
 */
export function QrCode({ value, label, size = 220, className }: {
  value: string;
  label: string;
  size?: number;
  className?: string;
}) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setSvg(null);
    if (!value) return undefined;
    QRCode.toString(value, { type: 'svg', margin: 1, width: size, color: { dark: '#000000', light: '#FFFFFF' } })
      .then((s) => { if (!cancelled) setSvg(s); })
      .catch(() => { if (!cancelled) setSvg(null); });
    return () => { cancelled = true; };
  }, [value, size]);

  if (!svg) return <div style={{ width: size, height: size }} className={cn('rounded-lg border-2 border-border', className)} aria-hidden />;
  return (
    <img
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`}
      alt={label}
      width={size}
      height={size}
      className={cn('rounded-lg border-2 border-border bg-white', className)}
    />
  );
}
